<template>
  <section class="tabela">
    <div class="cabecalho-tabela">
      <h4>Lista de atividades</h4>
      <div class="btn-cadastro-central-coord">
        <button @click.prevent="cadastrarAtividade()">
          Cadastrar atividade
        </button>
      </div>
    </div>
    <Carregamento
      v-if="carregando"
      :mensagemCarregamento="'Carregando Atividades'"
    />
    <div
      v-else
      class="listagem-central-coordenacao"
    >
      <div class="grid-tabela-cc cabecalho-container">
        <div class="coluna-cabecalho">Nome</div>
        <div class="coluna-cabecalho">Data Cadastro</div>
        <div class="coluna-cabecalho">Nº de participantes</div>
        <div class="coluna-cabecalho">Status</div>
        <div class="coluna-cabecalho"></div>
      </div>

      <div class="itens-cc">
        <div
          v-if="erro"
          class="mensagem-erro"
        >
          {{ erro }}
        </div>
        <div
          v-else-if="atividades.length === 0"
          class="mensagem-vazia"
        >
          Nenhuma atividade encontrada
        </div>
        <div
          v-else
          class="item-container-cc"
          v-for="(atividade, index) in atividades"
          :key="index"
          :class="{
            'item-selecionado-cc':
              showAcoes == index || mostrarSelecao == index,
          }"
        >
          <!-- resto do código -->

          <div class="grid-tabela-cc item-cc">
            <div class="celula-cc">{{ atividade.nome }}</div>
            <div class="celula-cc">
              {{ formatarData(atividade.dataCadastro) }}
            </div>
            <div class="celula-cc">{{ atividade.numeroDeParticipantes }}</div>
            <div
              class="celula-cc status"
              :class="{
                encerrada: atividade.status == 'ENCERRADA',
                'em-execucao': atividade.status == 'EM_EXECUCAO',
                programada: atividade.status == 'PROGRAMADA',
                cancelada: atividade.status == 'CANCELADA',
                concluida: atividade.status == 'CONCLUIDA',
                finalizar: atividade.status == 'FINALIZAR',
                aberta: atividade.status == 'INSCRICOES_ABERTAS',
              }"
            >
              <p>{{ formatarEnum(atividade.status) }}</p>
            </div>
            <div
              class="celula-cc btn-celula-cc"
              @click="
                showAcoes === index ? (showAcoes = null) : (showAcoes = index)
              "
              @mouseenter="mostrarSelecao = index"
              @mouseout="mostrarSelecao = null"
            >
              Opções
            </div>
          </div>
          <div
            class="menu-item-selecionado-cc"
            v-show="showAcoes === index"
          >
            <div
              v-if="
                atividade.modalidadeInscricao === 'NESCESSITA_INSCRICAO' &&
                !['CANCELADA', 'ENCERRADA', 'FINALIZADO', 'CONCLUIDA'].includes(
                  atividade.status
                )
              "
              class="acoes-item-selecionado"
              @click="abrirFrequencia(atividade)"
            >
              Frequência
            </div>
            <div
              class="acoes-item-selecionado"
              @click="abrirEquipe(atividade)"
            >
              Equipe
            </div>
            <div class="acoes-item-selecionado">Tarefas</div>
            <div
              v-if="
                !['CANCELADA', 'ENCERRADA', 'FINALIZADO', 'CONCLUIDA'].includes(
                  atividade.status
                )
              "
              class="acoes-item-selecionado"
              @click="encerrarAtividade(atividade.id)"
            >
              Encerrar
            </div>
            <div
              class="acoes-item-selecionado"
              @click="abrirAtividade(atividade.id)"
            >
              Abrir
            </div>
            <div
              v-if="
                !['CANCELADA', 'ENCERRADA', 'FINALIZADO', 'CONCLUIDA'].includes(
                  atividade.status
                )
              "
              class="acoes-item-selecionado"
              @click="editarAtividade(atividade)"
            >
              Editar
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <RouterView />

  <FrequenciaEncontro
    v-if="$route.query.modal === 'frequencia-encontro'"
    @fechar="fecharTela()"
  ></FrequenciaEncontro>
  <GestaoDeEquipe
    v-else-if="false"
    :atividadeId="atividadeSelecionada.id"
    :acaoId="props.acaoId"
    @fecharGestaoDeEquipe="equipe = false"
  />
  <FormCadastroAtividade
    v-if="route.query.modal === 'cadastrar-atividade'"
    :acaoId="props.acaoId"
  />
  <FormEditarAtividade
    v-if="route.query.modal === 'editar-atividade'"
    :acaoId="props.acaoId"
  />
</template>

<script setup>
import { onMounted, ref } from "vue";
import FrequenciaEncontro from "@/components/encontros/FrequenciaEncontro.vue";
import GestaoDeEquipe from "@/components/atividades/GestaoDeEquipe.vue";
import FormCadastroAtividade from "@/components/atividades/FormCadastroAtividade.vue";
import { formatarData, formatarEnum } from "@/utils/FormatarEntradas";
import atividadeService from "@/service/atividadeService";
import { useRoute } from "vue-router";
import router from "@/router";
import FormEditarAtividade from "@/components/atividades/FormEditarAtividade.vue";
import Carregamento from "@/components/common/Carregamento.vue";

const props = defineProps({
  acaoId: {
    type: String,
    required: true,
  },
});

const atividades = ref([]);
const equipe = ref(false);
const showAcoes = ref(null);
const mostrarSelecao = ref(null);
const frequencia = ref(false);
const atividadeSelecionada = ref({});
const carregando = ref(true);
const erro = ref(null);
const route = useRoute();

onMounted(async () => {
  try {
    carregando.value = true;
    const response = await atividadeService.getAtividadesAcao(
      0,
      1000,
      props.acaoId,
      false
    );

    if (response && response.length > 0) {
      atividades.value = response.filter(
        (atividade) => atividade.acaoUrl?.split("/").pop() == props.acaoId
      );
    } else {
      atividades.value = [];
    }
  } catch (error) {
    console.error("Erro ao carregar atividades:", error);
    erro.value = "Erro ao carregar atividades";
    atividades.value = [];
  } finally {
    carregando.value = false;
  }
});

async function encerrarAtividade(atividadeId) {
  try {
    await atividadeService.encerrarAtividade(atividadeId);
    // Recarregar a lista após encerrar
    const response = await atividadeService.getAtividadesAcao(
      0,
      1000,
      props.acaoId,
      false
    );
    if (response && response.length > 0) {
      atividades.value = response.filter(
        (atividade) => atividade.acaoUrl?.split("/").pop() == props.acaoId
      );
    } else {
      atividades.value = [];
    }
  } catch (error) {
    console.error("Erro ao encerrar atividade:", error);
  }
}

function abrirFrequencia(atividade) {
  atividadeSelecionada.value = atividade;
  router.push({
    query: {
      modal: "frequencia-encontro",
      atividadeId: atividade.id,
    },
  });
}

function abrirAtividade(atividadeId) {
  router.push(`/acao/${props.acaoId}/Atividades/${atividadeId}`);
}

function editarAtividade(atividade) {
  router.push({
    name: "editar-atividade",
    params: {
      id: props.acaoId,
      atividadeId: atividade.id,
    },
  });
}

function abrirEquipe(atividade) {
  atividadeSelecionada.value = atividade;
  equipe.value = true;
}

function cadastrarAtividade() {
  router.push({ name: "cadastrar-atividade" });
}

function fecharTela() {
  router.push({ query: {} });
}
</script>

<style scoped>
.encerrada p {
  background-color: rgba(255, 14, 14, 0.3);
}

.em-execucao p {
  background-color: rgba(255, 123, 0, 0.3);
}

.programada p {
  background-color: rgba(33, 150, 243, 0.3);
}

.cancelada p {
  background-color: rgba(255, 14, 14, 0.3);
}

.concluida p {
  background-color: rgba(39, 212, 27, 0.3);
}

.finalizar p {
  background-color: rgba(0, 31, 98, 0.3);
}

.aberta p {
  background-color: rgba(114, 47, 162, 0.3);
}
</style>
